import type { PayloadAction } from "@reduxjs/toolkit";
import { createSlice } from "@reduxjs/toolkit";
import type { CategoryType } from "../../../../../common-deprecated/types/CommonTypes";

export type ExtraFilterType = {
    searchValue: string;
    appliedCategoryFilters: CategoryType[];
};

const initialState: ExtraFilterType = {
    searchValue: "",
    appliedCategoryFilters: [],
};

export type CarConfigExtraFilterActionType = ReturnType<
    typeof addCategoryFilter | typeof removeCategoryFilter | typeof updateSearchValue
>;
export const CarConfigExtraFilterSlice = createSlice({
    name: "extraFilter",
    initialState,
    reducers: {
        updateSearchValue(state, action: PayloadAction<string>) {
            return {
                ...state,
                searchValue: action.payload,
            };
        },
        addCategoryFilter(state, action: PayloadAction<{ category: CategoryType }>) {
            return {
                ...state,
                appliedCategoryFilters: [...state.appliedCategoryFilters, action.payload.category],
            };
        },
        removeCategoryFilter(state, action: PayloadAction<{ category: CategoryType }>) {
            return {
                ...state,
                appliedCategoryFilters: state.appliedCategoryFilters.filter(
                    (filterCategory) => filterCategory.id !== action.payload.category.id,
                ),
            };
        },
    },
});

export const { updateSearchValue, addCategoryFilter, removeCategoryFilter } = CarConfigExtraFilterSlice.actions;
